import { RootState } from 'store';

const RegionsLookupState = (state: RootState) => state.lookups.regions;
export const selectRegions = (state: RootState) => RegionsLookupState(state).rows;
